import { useCallback, useMemo } from 'react';
import { useOpenBankLoginForSecondConnection } from 'features/link-bank/hooks/useOpenBankLoginForSecondConnection';
import { useOpenConnectionLogin } from 'hooks/useOpenConnectionLogin';
import { selectConnections } from 'reducers/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { formatPlural } from 'utils/formatting';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { setPendingConnectionRefetch } from '../actions';
const strings = {
    renewTitle: (bankName) => `Add account from ${bankName}`,
    renewDescription: (bankName, openAccountsCount) => `When you reach ${bankName}, select your new account alongside your existing ${formatPlural('account', 'accounts', openAccountsCount)} listed below. Deselecting ${formatPlural('your existing account', 'any existing accounts', openAccountsCount)} will disconnect ${formatPlural('it', 'them', openAccountsCount)} from Emma.`,
};
const useConnectToSuggestedBank = (suggestion, routeKey) => {
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    const banks = useAppSelector((state) => state.linkBank.banks);
    const openBankLogin = useOpenBankLoginForSecondConnection(routeKey);
    const bankId = suggestion?.bankId;
    const bank = bankId == null ? undefined : banks.find(({ id }) => id === bankId);
    const existingConnection = useAppSelector((state) => bankId == null
        ? undefined
        : selectConnections(state).find((connection) => connection.bankId === bankId && !connection.isClosed));
    const renewCopyOverrides = useMemo(() => {
        if (!existingConnection)
            return undefined;
        const openAccountsCount = existingConnection.accounts.filter((account) => !account.isClosed).length;
        return {
            title: strings.renewTitle(existingConnection.bankInfo.name),
            description: strings.renewDescription(existingConnection.bankInfo.name, openAccountsCount),
        };
    }, [existingConnection]);
    const openConnectionLogin = useOpenConnectionLogin(navigation, renewCopyOverrides?.title, renewCopyOverrides?.description);
    const onConnect = useCallback(() => {
        if (!bank)
            return;
        if (existingConnection) {
            dispatch(setPendingConnectionRefetch());
            openConnectionLogin({ type: 'connection', data: existingConnection });
            return;
        }
        openBankLogin(bank);
    }, [bank, dispatch, existingConnection, openBankLogin, openConnectionLogin]);
    return bank ? onConnect : null;
};
export default useConnectToSuggestedBank;
